import { createSelector } from 'redux-orm';

import orm from '../orm';

export const selectContentCardDefaultsForPointSystem = createSelector(
  orm,
  (_, pointSystemId) => pointSystemId,
  ({ ContentCardDefault }, pointSystemId) => {
    if (!pointSystemId) {
      return [];
    }

    return ContentCardDefault.all()
      .filter({ pointSistemId: pointSystemId })
      .orderBy('sort')
      .toRefArray();
  },
);

export const selectContentCardDefaultsByPointSystemAndType = createSelector(
  orm,
  (_, pointSystemId) => pointSystemId,
  (_, __, type) => type,
  ({ ContentCardDefault }, pointSystemId, type) => {
    if (!pointSystemId) {
      return [];
    }

    const query = ContentCardDefault.all().filter({
      pointSistemId: pointSystemId,
    });

    if (type) {
      return query.filter({ type }).orderBy('sort').toRefArray();
    }

    return query.orderBy('sort').toRefArray();
  },
);

export default {
  selectContentCardDefaultsForPointSystem,
  selectContentCardDefaultsByPointSystemAndType,
};

